export const API_REQUEST_HEADERS = {
  /** The authorization bearer header. */
  AUTHORIZATION: 'Authorization',
  /** The active tenant database instance header. */
  GATSHIP_ACTIVE_TENANT_DB_INSTANCE: 'Gatship-Active-Tenant-DB-Instance',
  /** The command ID header. */
  GATSHIP_COMMAND_ID: 'Gatship-Command-ID',
  /** The app session ID header. */
  GATSHIP_APP_SESSION_ID: 'Gatship-App-Session-ID',
  /** The support session token header. */
  GATSHIP_SUPPORT_SESSION_TOKEN: 'Gatship-Support-Session-Token'
} as const
